import React from "react";
import { Link } from "react-router-dom";

const ArrowRightIcon = ({ className = "w-4 h-4 text-blue-400" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={`ml-2 transition-transform group-hover/btn:translate-x-1 ${className}`}>
    <path d="M5 12h14" />
    <path d="m12 5 7 7-7 7" />
  </svg>
);

const TruckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-blue-400">
    <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" />
    <path d="M15 18H9" />
    <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14" />
    <circle cx="17" cy="18" r="2" />
    <circle cx="7" cy="18" r="2" />
  </svg>
);

const PlugIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-emerald-400">
    <path d="M12 22v-5" />
    <path d="M9 8V2" />
    <path d="M15 8V2" />
    <path d="M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z" />
  </svg>
);

const BuildingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-amber-400">
    <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" />
    <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" />
    <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" />
    <path d="M10 6h4" />
    <path d="M10 10h4" />
    <path d="M10 14h4" />
    <path d="M10 18h4" />
  </svg>
);

const ScaleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-purple-400">
    <path d="m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z" />
    <path d="m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z" />
    <path d="M7 21h10" />
    <path d="M12 3v18" />
    <path d="M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2" />
  </svg>
);

const ClockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-3.5 h-3.5">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const cards = [
  {
    title: "Fleet Owners",
    description: "Convert your fleet to electric while minimizing your TCO.",
    tags: ["Route Analysis", "Cost Modeling", "Charging Scheduling"],
    href: "/solutions/fleet",
    image: "/img/homepage/fleet-owner-bg.png",
    imageAlt: "Fleet owner operations and vehicle planning",
    gradient: "from-blue-500 to-cyan-500",
    iconBg: "bg-blue-500/10",
    Icon: TruckIcon,
    cta: "Learn More",
    gradientText: "from-blue-500 to-cyan-500",
    arrowClass: "text-blue-400",
  },
  {
    title: "Charging Providers",
    description: "Locate sites for charging stations where trucks already cluster.",
    tags: ["Location Optimization", "Demand Forecasting", "Capacity Analysis"],
    href: "/solutions/charging",
    image: "/img/homepage/charging.png",
    imageAlt: "Electric vehicle charging infrastructure",
    gradient: "from-emerald-500 to-teal-500",
    iconBg: "bg-emerald-500/10",
    Icon: PlugIcon,
    cta: "Learn More",
    gradientText: "from-emerald-500 to-teal-500",
    arrowClass: "text-emerald-400",
  },
  {
    title: "Utilities",
    description: "Learn more about where your electric grid is headed.",
    tags: ["Load Forecasting", "Demand Response", "Smart Charging"],
    image: "/img/homepage/utility.png",
    imageAlt: "Utility planning and electric grid management",
    gradient: "from-amber-500 to-orange-500",
    iconBg: "bg-amber-500/10",
    Icon: BuildingIcon,
    cta: "Coming Soon",
    arrowClass: "text-amber-400",
    comingSoon: true,
  },
  {
    title: "Regulators",
    description: "Get a deeper understanding of how new development shapes the environment.",
    tags: ["Policy Analysis", "Impact Modeling", "Scenario Planning"],
    href: "/solutions/regulator",
    image: "/img/homepage/regulator.png",
    imageAlt: "Regulatory policy analysis and EV planning",
    gradient: "from-purple-500 to-pink-500",
    iconBg: "bg-purple-500/10",
    Icon: ScaleIcon,
    cta: "Learn More",
    arrowClass: "text-purple-400",
  },
];

export const LandingWhatWeDo = ({
  eyebrow = "Solutions",
}) => (
  <section id="solutions" className="scroll-mt-24 bg-white py-10 md:py-14">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <h2 className="mb-6 text-lg font-semibold uppercase tracking-wider text-blue-700 md:text-xl">
        {eyebrow}
      </h2>
      <div className="grid gap-4 md:grid-cols-2">
        {cards.map((card) => (
          <div key={card.title} className="group flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-4 transition hover:border-slate-300 sm:p-5">
            <div className="grid gap-3 sm:grid-cols-2 sm:items-stretch sm:gap-4">
              <div className="relative h-32 overflow-hidden rounded-xl border border-slate-100 sm:h-auto sm:aspect-[4/3] sm:self-start">
                <img
                  src={card.image}
                  alt={card.imageAlt}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${card.gradient} opacity-20`} />
              </div>

              <div className="flex min-w-0 flex-col">
                <div className="mb-2 flex items-center gap-2.5">
                  <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${card.iconBg}`}>
                    <card.Icon />
                  </div>
                  <h3 className="text-base font-semibold leading-snug text-slate-900 sm:text-lg">{card.title}</h3>
                </div>
                <p className="flex-1 text-sm leading-relaxed text-slate-600">{card.description}</p>
                {card.href ? (
                  <Link
                    to={card.href}
                    className={`group/btn mt-3 inline-flex items-center gap-2 text-sm font-semibold ${card.arrowClass} hover:underline`}
                  >
                    {card.cta}
                    <ArrowRightIcon className={card.arrowClass} />
                  </Link>
                ) : (
                  card.comingSoon && (
                    <span className="mt-3 inline-flex w-fit items-center gap-1.5 rounded-full border border-slate-200 bg-slate-100 px-2.5 py-1 text-xs font-medium text-slate-600">
                      <ClockIcon />
                      Coming Soon
                    </span>
                  )
                )}
              </div>
            </div>

            <div className="mt-3 border-t border-slate-100 pt-3">
              <div className="flex flex-wrap gap-1.5">
                {card.tags.map((tag) => (
                  <span key={tag} className="rounded-full bg-slate-100 px-2.5 py-0.5 text-xs font-medium text-slate-700">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
